import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_countries = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/country/`,
        method: "GET"
    })
}

export const fetch_country_by_id = async (country_id) => {
    if (!country_id) return { error: "No country id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/country/id/${country_id}`,
        method: "GET"
    })
}
